import { Injectable } from '@angular/core';
import { translate } from '@ngneat/transloco';
import { IDrivePackDescriptionList } from '@app/order/selection/drive/drive.interfaces';

@Injectable()
export class DriveService {
  public getPackDescription(packId: number): Array<IDrivePackDescriptionList> {
    const onlyOfficeDesc = {
      description: translate('Édition de fichiers avec <strong>OnlyOffice</strong>'),
    };
    switch (packId) {
      case 0:
        return [
          {
            description: translate('<strong>1 utilisateur</strong> maximum'),
          },
          {
            description: translate('$nb$ versions de fichiers anterieures', { nb: 30 }),
            tooltip:
              translate('Des que vous modifiez un fichier dans kDrive, une version est automatiquement cree.') +
              ' ' +
              translate(
                'Cette fonctionnalite est tres utile pour recuperer des informations supprimees dont vous pourriez avoir besoin.'
              ) +
              ' ' +
              translate('Avec le plan $pack$, les versions des fichiers sont conservees pendant $nb$ jours.', {
                pack: 'Free',
                nb: 30,
              }),
          },
          onlyOfficeDesc,
        ];
      case 1:
        return [
          {
            description: translate('<strong>1 utilisateur</strong> maximum'),
          },
          {
            description: translate('Boites de depot'),
            tooltip: translate(
              "Les boites de depot vous permettent d'envoyer un lien aux contacts de votre choix pour leur demander de transferer des fichiers dans votre kDrive, meme s'ils n'ont pas de compte Infomaniak"
            ),
          },
          {
            description: translate('Liens de partage avances'),
          },
          {
            description: translate('Support du protocole WebDAV'),
          },
          {
            description: translate('Assistance 7j/7'),
          },
          {
            description: translate('$nb$ versions de fichiers anterieures', { nb: 100 }),
            tooltip:
              translate('Des que vous modifiez un fichier dans kDrive, une version est automatiquement cree.') +
              ' ' +
              translate(
                'Cette fonctionnalite est tres utile pour recuperer des informations supprimees dont vous pourriez avoir besoin.'
              ) +
              ' ' +
              translate('Avec le plan $pack$, les versions des fichiers sont conservees pendant $nb$ jours.', {
                pack: 'Solo',
                nb: 60,
              }),
          },
          onlyOfficeDesc,
        ];
      case 2:
        return [
          {
            description: translate('<strong>$nb$ utilisateurs</strong> maximum', { nb: 6 }),
          },
          {
            description: translate('Boites de depot'),
            tooltip: translate(
              "Les boites de depot vous permettent d'envoyer un lien aux contacts de votre choix pour leur demander de transferer des fichiers dans votre kDrive, meme s'ils n'ont pas de compte Infomaniak"
            ),
          },
          {
            description: translate('Liens de partage avances'),
          },
          {
            description: translate('Support du protocole WebDAV'),
          },
          {
            description: translate('Assistance 7j/7'),
          },
          {
            description: translate('$nb$ versions de fichiers anterieures', { nb: 100 }),
            tooltip:
              translate('Des que vous modifiez un fichier dans kDrive, une version est automatiquement cree.') +
              ' ' +
              translate(
                'Cette fonctionnalite est tres utile pour recuperer des informations supprimees dont vous pourriez avoir besoin.'
              ) +
              ' ' +
              translate('Avec le plan $pack$, les versions des fichiers sont conservees pendant $nb$ jours.', {
                pack: 'Team',
                nb: 60,
              }),
          },
          {
            description: translate('Dossiers communs'),
            tooltip: translate(
              'Les dossiers communs sont parfaits pour collaborer en equipe ou pour donner acces a des ressources communes aux utilsateurs de votre choix.'
            ),
          },
          {
            description: translate('Gestion des roles et des droits des utilsateurs'),
          },
          {
            description: translate('Gestion des donnees des utilisateurs supprimes'),
          },
          onlyOfficeDesc,
        ];
      case 3:
        return [
          {
            description: translate("Nombre d'utilisateurs extensible"),
          },
          {
            description: translate('Boites de depot'),
            tooltip: translate(
              "Les boites de depot vous permettent d'envoyer un lien aux contacts de votre choix pour leur demander de transferer des fichiers dans votre kDrive, meme s'ils n'ont pas de compte Infomaniak"
            ),
          },
          {
            description: translate('Liens de partage avances'),
          },
          {
            description: translate('Support du protocole WebDAV'),
          },
          {
            description: translate('Assistance 7j/7'),
          },
          {
            description: translate('$nb$ versions de fichiers anterieures', { nb: 200 }),
            tooltip:
              translate('Des que vous modifiez un fichier dans kDrive, une version est automatiquement cree.') +
              ' ' +
              translate(
                'Cette fonctionnalite est tres utile pour recuperer des informations supprimees dont vous pourriez avoir besoin.'
              ) +
              ' ' +
              translate('Avec le plan $pack$, les versions des fichiers sont conservees pendant $nb$ jours.', {
                pack: 'Pro',
                nb: 120,
              }),
          },
          {
            description: translate('Dossiers communs'),
            tooltip: translate(
              'Les dossiers communs sont parfaits pour collaborer en equipe ou pour donner acces a des ressources communes aux utilsateurs de votre choix.'
            ),
          },
          {
            description: translate('Gestion des roles et des droits des utilsateurs'),
          },
          {
            description: translate('Gestion des donnees des utilisateurs supprimes'),
          },
          {
            description: translate('Édition de fichiers avec <strong>OnlyOffice ou Microsoft Office Online</strong>'),
          },
        ];
      default:
        return [];
    }
  }

  public getPackSettings(packId: number): Array<string> {
    switch (packId) {
      case 0:
        return [translate('$num$ Go', { num: '15' }), translate('1 utilisateur')];
      case 1:
        return [translate('$num$ To', { num: '3' }), translate('1 utilisateur')];
      case 2:
        return [translate('Des $nb$ To', { nb: 3 }), translate('$nb$ utilisateurs', { nb: 6 })];
      case 3:
        return [translate('Des $nb$ To', { nb: 6 }), translate('Des $nb$ utilisateurs', { nb: 3 })];
      default:
        return [];
    }
  }
}
